class SessionTracker {
    constructor(phase, videoDuration, novelObjectPosition, endSessionCallback) {
        if (phase == null || videoDuration == null || videoDuration === 0)
            throw Error("Phase and video duration must be specified");
        else if (phase === "test" && novelObjectPosition == null)
            throw Error("Novel object position must be null in test phase.");
        else {
            this.phase = phase;
            this.videoDuration = videoDuration;
            this.novelObjectPosition = novelObjectPosition;

            // Set timers
            this.sessionStartTime = null;
            this.lastEventTime = null;
            this.sessionEndTime = null;
            // Set time totals
            this.exploreTime = 0;
            this.leftTime = 0;
            this.rightTime = 0;
            this.leftBoutCount = 0;
            this.rightBoutCount = 0;
            // Set participant current state
            // Can be "exploring", "left" or "right"
            this.exploreState = "exploring";
            this.sessionEnded = false;

            this.endSessionCallback = endSessionCallback;

            this.intervalTimer = null;
            this.dataUpdateCallback = null;
            this.mousePositionUpdateCallback = null;
            //this.StartRecording();
        }
    }

    StartRecording() {
        this.sessionStartTime = Date.now();
        this.lastEventTime = this.sessionStartTime;
        this.intervalTimer = setInterval(() => {
            if (this.dataUpdateCallback) {
                let leftTotalTime = this.leftTime;
                let rightTotalTime = this.rightTime;

                if (this.exploreState === "left")
                    leftTotalTime += Date.now() - this.lastEventTime;
                else if (this.exploreState === "right")
                    rightTotalTime += Date.now() - this.lastEventTime;
                let activityData = { leftTime: leftTotalTime, leftCount: this.leftBoutCount, rightTime: rightTotalTime, rightCount: this.rightBoutCount, totalTime: leftTotalTime + rightTotalTime ?? 0, timePassed: Date.now() - this.sessionStartTime }
                this.dataUpdateCallback(activityData);
            }
            this.SessionEnded();
        }, 10);
    }

    SetDataUpdateCallback(callback) {
        this.dataUpdateCallback = callback;
    }

    SetMousePositionUpdateCallback(callback) {
        this.mousePositionUpdateCallback = callback;
    }

    HandleLeftEvent() {
        this.HandleEvent("left");
    }

    HandleRightEvent() {
        this.HandleEvent("right")
    }

    HandleEvent(event) {
        if (this.exploreState === "exploring") {
            this.RecordExploringTime();
            this.exploreState = event;
        }
        else {
            this.RecordTimeAtObject(this.exploreState);
            this.exploreState = "exploring";
        }

        if (this.mousePositionUpdateCallback)
            this.mousePositionUpdateCallback(this.exploreState);
    }

    RecordTimeAtObject(obj) {
        let duration = this.SetLatestEvent();
        if (obj === "left") {
            this.leftTime += duration;
            this.leftBoutCount += 1;
        } else {
            this.rightTime += duration;
            this.rightBoutCount += 1;
        }
    }

    RecordExploringTime() {
        const durationExploring = this.SetLatestEvent()
        this.exploreTime += durationExploring
        //let durationDecimalSeconds = this.GetDecimalSeconds(durationExploring)
    }

    SetLatestEvent() {
        const thisEventTime = Date.now()
        const duration = thisEventTime - this.lastEventTime
        this.lastEventTime = thisEventTime
        return duration
    }

    GetDecimalSeconds(td) {
        const ans = td / 1000;
        return ans.toFixed(3);
    }

    SessionStarted() {
        return this.sessionStartTime != null;
    }

    SessionEnded() {
        let durationFinished = (Date.now() - this.sessionStartTime) >= this.videoDuration * 1000
        if (durationFinished)
            this.EndSession()
        return this.sessionEnded
    }

    EndSession() {
        this.sessionEnded = true;
        if (Date.now() - this.sessionStartTime > (this.videoDuration * 1000))
            this.sessionEndTime = new Date(this.sessionStartTime + (this.videoDuration * 1000));
        else
            this.sessionEndTime = Date.now();
        this.RecordLastEvent();
        if (this.dataUpdateCallback) {
            let activityData = { leftTime: this.leftTime, leftCount: this.leftBoutCount, rightTime: this.rightTime, rightCount: this.rightBoutCount, totalTime: this.leftTime + this.rightTime ?? 0, timePassed: this.sessionEndTime - this.sessionStartTime }
            this.dataUpdateCallback(activityData);
        }
        if (this.mousePositionUpdateCallback)
            this.mousePositionUpdateCallback("exploring");
        this.endSessionCallback();
        clearInterval(this.intervalTimer);
        //this.PrintStats()
    }

    RecordLastEvent() {
        //const duration = this.sessionEndTime - this.lastEventTime
        if (this.exploreState === "exploring")
            this.RecordExploringTime()
        else if (this.exploreState === "left")
            this.RecordTimeAtObject("left")
        else
            this.RecordTimeAtObject("right")
    }

    TotalBouts() {
        return this.leftBoutCount + this.rightBoutCount
    }
}

export default SessionTracker;